import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Actions from 'datamodel/SearchFilters/actions';
import { getPlaceType } from 'datamodel/SearchFilters/utils';
import { getPathName } from 'base/shared/Utils';
import { HOUSING_SECTION } from '../../constants';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 2rem;
  }
`;

const MainTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 2rem;
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 245px);
  gap: 2rem;
  margin-top: 2rem;
  justify-content: center;
`;

const Card = styled.div`
  background: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  width: 245px;
  height: 345px;

  &:hover {
    transform: translateY(-4px);
  }
`;

const CardImage = styled.div`
  height: 345px;
  width: 100%;
  background-image: url('${(props) => props.$imageUrl}');
  background-size: cover;
  background-position: center;
  position: relative;
  cursor: pointer;
`;

const Badge = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: linear-gradient(135deg, #ffe193 0%, #ffc55e 100%);
  color: black;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const CardContent = styled.div`
  padding: 1rem 0;
  text-align: center;
  width: 245px;
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const CardDescription = styled.p`
  color: #6b7280;
  line-height: 1.5;
  text-align: center;
`;

const AllRoomsSection = ({ setParams }) => {
  const handleSearch = ({ label, placeTypes: selectedType }) => {
    const placeTypes = getPlaceType();

    const index = placeTypes.findIndex(({ id }) => id === selectedType);
    placeTypes[index] = { ...placeTypes[index], selected: true };

    setParams({
      label,
      placeTypes,
    });
  };

  return (
    <Container>
      <MainTitle>{translate(HOUSING_SECTION.title)}</MainTitle>
      <Subtitle>{translate(HOUSING_SECTION.description)}</Subtitle>

      <Grid>
        {HOUSING_SECTION.resources.map((resource) => (
          <div key={resource.id}>
            {resource.search ? (
              <div>
                <Card>
                  <CardImage
                    $imageUrl={resource.image}
                    onClick={() => handleSearch(resource.search)}
                  >
                    {resource.badge && <Badge>{resource.badge}</Badge>}
                  </CardImage>
                </Card>
                <CardContent>
                  <CardTitle>{translate(resource.title)}</CardTitle>
                  <CardDescription>{translate(resource.description)}</CardDescription>
                </CardContent>
              </div>
            ) : (
              <a
                href={getPathName(resource.link)}
                target="_self"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Card>
                  <CardImage $imageUrl={resource.image}>
                    {resource.badge && <Badge>{translate(resource.badge)}</Badge>}
                  </CardImage>
                </Card>
                <CardContent>
                  <CardTitle>{translate(resource.title)}</CardTitle>
                  <CardDescription>{translate(resource.description)}</CardDescription>
                </CardContent>
              </a>
            )}
          </div>
        ))}
      </Grid>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setParams: (searchFilters) =>
    dispatch(
      Actions.setParams({
        searchFilters: { ...searchFilters, updatedFilters: true },
      })
    ),
});

export default connect(null, mapDispatchToProps)(AllRoomsSection);
